import { createElement, MouseEvent, Props as ReactProps, ReactElement } from 'react';
import { DependencyProps } from '../../../core/dependency';
import { LocationProps } from '../../../core/location';
import { StateProps } from '../../../core/state';
import { Layout, Spin } from 'antd';
import styled from 'styled-components';
import applyGlobalStyles from '../../../applyGlobalStyles';

type Props = ReactProps<HTMLDivElement> &
  DependencyProps &
  StateProps &
  LocationProps & {
    header?: ReactElement<any> | null;
    content: ReactElement<any> | ReactElement<any>[];
    sidebar: ReactElement<any>;
    onClickNewButton?: (e: MouseEvent<HTMLAnchorElement>) => void;
    newButtonDisabled?: boolean;
    isSpinner?: boolean;
    isPanel?: boolean;
  };

const { Header, Sider, Content } = Layout;

const StyledSider = styled(Sider)`
  background: transparent !important;
  border-right: 1px solid #e8e8e8;
`;

const StyledLayout = styled(Layout)`
  width: 100%;
  height: 100%;
`;

const StyledContent = styled(Content)`
  padding: 20px;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

const StyledContentHeader = styled(Header)`
  height: auto !important;
  line-height: unset;
  padding: 20px 50px;
`;

const SidebarFrame = (
  {
    content,
    sidebar,
    header,
    isSpinner = false,
  }: Props) => (
  <StyledLayout>
    <StyledSider>{sidebar}</StyledSider>

    <StyledLayout>
      <Layout>
        <StyledContentHeader>{header}</StyledContentHeader>
        <StyledContent>
          {isSpinner ? <Spin>{content}</Spin> : content}
        </StyledContent>
      </Layout>
    </StyledLayout>
    {applyGlobalStyles()}
  </StyledLayout>
);

export default SidebarFrame;
